import React, { useState, useEffect } from 'react'
import glamorous from 'glamorous'
import Table from 'antd/lib/table'
import Tooltip from 'antd/lib/tooltip'
import Button from 'antd/lib/button'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import { message, notification, Icon } from "antd";
import map from 'lodash/fp/map'
import uniq from 'lodash/fp/uniq'
import pick from 'lodash/fp/pick'
import filter from 'lodash/fp/filter'
import gspAuth from "../../services/GSPService";
import get from 'lodash/fp/get'
import reduce from 'lodash/fp/reduce'
import flow from 'lodash/fp/flow'
import flatMap from 'lodash/fp/flatMap'
import { formatNumber } from "../../shared/constants";
import { PR_B2B_PurchaseQuery, CompanyByIdQuery } from 'qgst-gql-queries/web/data.json'
import { gql, graphql, compose } from 'react-apollo'
import { connect } from 'react-redux'
import PrB2BItems from './PR_B2B_Items'
import { Root, ContentWrapper as Content } from '../../shared/styles'
import moment from 'moment'
const row_style = { border: 'solid 1px #e8e8e8', padding: '10px', margin: '1px' };
const row_text_style = { border: 'solid 1px #e8e8e8', margin: '1px'};
const { ColumnGroup, Column } = Table
const SRow = glamorous(Row)({margin: '0px 0',})


const PurchaseRegister = props => {
  function compareByAlph(a, b) {
   if (a < b) {
      return -1;
    } if (a > b) {
      return 1;
    } else{
      return 0;
    }
  }
  console.log(props);
  // State to track screen width for dynamic button text
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  // Update screen width on resize
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Dynamic button text based on screen size
  const fetchButtonText = isSmallScreen ? 'Fetch missing Supplier ...' : 'Fetch missing Supplier Name(s)';

  // Use row_style if provided, otherwise fallback
  const row_style = props.row_style || {};
  return (
    <Root>
      <Content>
      <SRow gutter={24} style={{marginBottom:'2%'}}>
      {/* Total Purchase Value */}
      <Col span={8}>
        <div
          style={{
            fontSize: '14px',
            // fontWeight: 'bold',
            // whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: '#000', // Ensure text is visible
          }}
        >
          Total Purchase Value: {' '}
          {props.formatNumber(
            reduce(
              (curr, next) => {
                curr = parseFloat(curr) + parseFloat(next?.invoice_value || 0, 2);
                const temp = parseFloat(curr).toFixed(2);
                return temp;
              },
              0
            )(props.pr_b2b_masters || [])
          ) || '0.00'} {/* Fallback value if undefined */}
        </div>
      </Col>

      {/* Total Taxable Value */}
      <Col span={8}>
        <div
          style={{
            fontSize: '14px',
            // fontWeight: 'bold',
            // whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: '#000', // Ensure text is visible
          }}
        >
          Total Taxable Value: {' '}
          {props.formatNumber(
            flow(
              flatMap(get('sr_b2b_items.edges')),
              reduce(
                (curr, next) => {
                  curr = parseFloat(curr) + parseFloat(next?.taxable_value || 0, 2);
                  const temp = parseFloat(curr).toFixed(2);
                  return temp;
                },
                0
              )
            )(props.pr_b2b_masters || [])
          ) || '0.00'} {/* Fallback value if undefined */}
        </div>
      </Col>

      {/* Fetch missing Supplier Name(s) Button */}
      <Col span={8} style={{display:"flex",justifyContent:"flex-end"}}>
        <Tooltip title="Fetch missing Supplier Name(s)">
          <Button
            style={{
              backgroundColor: '#2382c7',
              fontSize: isSmallScreen ? '12px' : '13px', // Smaller font on small screens
              color: 'white',
              // width: '100%',
              height: 'auto',
              padding: '8px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              // textOverflow: 'ellipsis',
              borderRadius: '4px', // Consistent button styling
            }}
            icon="sync"
            onClick={() => props.fetchMissingNames(props.pr_b2b_masters)}
          >
            {fetchButtonText}
          </Button>
        </Tooltip>
      </Col>
    </SRow>

        <Table dataSource={props.pr_b2b_masters} bordered rowKey="id" loading={props.loading} title={() => 'B2B Purchases'} pagination={{ className: 'my-pagination' }}>
          <Column title="Supplier GSTIN" dataIndex="supplier_gstin" key="supplier_gstin" />
          <Column title="Supplier Name" dataIndex="supplier_name" key="supplier_name" />
          <ColumnGroup title="Invoice Details">
            <Column title="No." dataIndex="invoice_number" key="invoice_number" sorter={(a, b) => compareByAlph(a.invoice_number, b.invoice_number)}/>
            <Column title="Date" dataIndex="invoice_date" key="invoice_date" render={text => moment(text, "DD-MM-YYYY").format('DD/MM/YYYY')}/>
            <Column title="Value" dataIndex="invoice_value" key="invoice_value" render={val => <p style={{ width: '115px'}}>{props.formatNumber(val === null ? 0 : val)}</p>} />
            <Column title="Type" dataIndex="invoice_type" key="invoice_type" />
          </ColumnGroup>
          <Column title="Place Of Supply" dataIndex="pos_id" key="pos_id" />
          <Column title="Supply Type" dataIndex="supply_type" key="supply_type" />
          <Column title="Reverse Charge" dataIndex="reverse_charge" key="reverse_charge" />
          <Column title="Items" key="pr_b2b_items"
            render={(text, record) => {
              console.log(record);
              return (
                <Tooltip title="View Item(s)">
                  <Button icon="switcher" style={{
                      background: 'linear-gradient(180deg, #FFFFFF 0%, #F0F0F0 100%)',
                      color: "black",
                  }} onClick={() => props.showModal(record.id)}>
                     {record.pr_b2b_items.pageInfo.total} Item(s)

                  </Button>
                  <PrB2BItems isVisible={props.visibleModal === record.id} onCancel={props.hideModal} pr_b2b_items={record.pr_b2b_items.edges}/>
                </Tooltip>
              )
            }}
          />
        </Table>
        <SRow gutter={24} style={row_text_style}>
          <Col span="24">
            <h3 style={{padding: '10px'}}>Invoice Types : Regular-Regular B2B Invoices, SEWP-SEZ Supplies with payment, SEWOP-SEZ Supplies without payment, DE-Deemed Exports</h3>
          </Col>
        </SRow>
        <script type="text/javascript" src="FileSaver.js"></script>
      </Content>
    </Root>
  )
}
class PurchaseRegisterContainer extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    var d = new Date();
    var n = d.getMonth();
    var y = d.getYear();
    var curyear = 1900 + y;
    var nextyear = curyear + 1 - 2000;
    var year =  curyear + '-' + nextyear;
    this.state = {
      visibleModal: null,
      finMonth: n+1,
      finYear: year,
      curFinMonth: n+1,
      curFinYear: year,
    }
    this.props.data.refetch()
  }

  fetchMissingNames = async missingCompanyName => {
      notification.destroy();
      message.destroy();
      message.loading('Fetching Names...',0);
      const listMissingCompanyName = filter({ supplier_name: '...' })(missingCompanyName);

      const gstinList = flow(
        map(d => {
          return pick(['supplier_gstin'])(d).supplier_gstin;
        }),
        uniq
      )(listMissingCompanyName);

      const isSuccess = await gspAuth.getListOfCompanyNames(gstinList, this.props.selectedCompany);

      if(isSuccess.data.success === true){
        this.props.data.refetch();
        message.destroy();
        message.success('Fetched');
      } else if(isSuccess.data.success === false){
        message.destroy();
        notification.destroy();
        notification.open({
          message: 'Fetch Unsuccessful',
          description: "Unable to process your request, please try again later.",
          duration: 0,
          icon: <Icon type="close-circle" style={{ color: '#db0f20' }} />,
        });
      }
  }

  showModal = async id => {
    this.setState({ visibleModal: id })
    console.log(id);

  }
  hideModal = () => {
    this.setState({ visibleModal: null })
  }
  changeSelectedFinancialMonth = name => {
    this.props.changeSelectedFinancialMonth(name)
  }
  render() {
    console.log('STATUS')
    console.log(this.props.data.networkStatus)
    var tableLoading = false;
    if (this.props.data.networkStatus === 4) { tableLoading = false;}
    else if (this.props.data.networkStatus === 7) { tableLoading = false; }
    else if (this.props.data.networkStatus === 1) { tableLoading = true; }
    return (
      <PurchaseRegister
        pr_b2b_masters={get('viewer.pr_b2b_masters.edges')(this.props.data)}
        role={get('company.role', this.props)}
        finMonth={this.state.finMonth}
		    finYear={this.state.finYear}
        loading={tableLoading}
        showModal={this.showModal}
        hideModal={this.hideModal}
        fetchMissingNames={this.fetchMissingNames}
        visibleModal={this.state.visibleModal}
        isSR={this.props.isSR}
        formatNumber={formatNumber}
      />
    )
  }
}

const queryConfig = {
  options: props => ({
    variables: {
      companyId: props.selectedCompany,
      // isSR: props.isSR,
      type: 'prb2b',
      finmonth: props.finMonth.toString(),
      finyear: props.finYear,
    },
  }),
}
const companyQueryConfig = {
  options: props => ({
    variables: {
      companyId: props.selectedCompany,
      finYear: props.finYear,
      finMonth: props.finMonth,
    },
  }),
  props: ({ data }) => {
    return {
      company: get('viewer.company', data),
      isEdit: true,
    }
  },
}

const mapStateToProps = state => {
  return {
    selectedCompany: state.local.selectedCompany,
    finMonth: state.local.finMonth,
    finYear: state.local.finYear,
  }
}

export default compose(
  connect(mapStateToProps),
  graphql(gql(PR_B2B_PurchaseQuery), queryConfig),
  graphql(gql(CompanyByIdQuery), companyQueryConfig)
)(PurchaseRegisterContainer)
